import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getSalonProfile = async (id: string | undefined) => {
    const { data, error } = await supabase
        .from('salons_profile')
        .select(`*, country(*)`)
        .eq('id', id)
        .single()

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetSalonById(id: string | undefined) {
    return useQuery({
        queryKey: ['useGetSalonById', id],
        queryFn: () => getSalonProfile(id || ''),
        staleTime: 0,
        enabled: !!id,
    })
}
